var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4500",
    className: "cls-1",
    d: "M20.3,2.8c.3,0,.5.2.5.5,0,.3-.2.5-.5.5-.3,0-.5-.2-.5-.5,0,0,0,0,0,0,0-.3.2-.5.5-.5M17.8,2.8c.3,0,.5.2.5.5,0,.3-.2.5-.5.5-.3,0-.5-.2-.5-.5,0,0,0,0,0,0,0-.3.2-.5.5-.5M15.3,2.8c.3,0,.5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5c0,0,0,0,0,0,0-.3.2-.5.5-.5M13.1,5v2.9c0,.2,0-1.6,2.5-1.6h5.7c.7,0,1.3-.6,1.3-1.3V1.3c0-.7-.6-1.3-1.3-1.3h-6.8c-.7,0-1.3.6-1.3,1.3v3.7h0ZM.7,14.1l3.7-3.7,1.7-7.6,11.2,11.2-7.6,1.7-.8.8,3.4,3.4c.3.3.3.8,0,1.1l-.8.8c-.3.3-.8.3-1.1,0l-3.4-3.4-1,1c-.9.9-2.3.9-3.2,0l-2.2-2.2c-.9-.9-.9-2.3,0-3.2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComms);
export default __webpack_public_path__ + "static/media/Comms.a74602132bcfc7e2a4bcda525a7859ed.svg";
export { ForwardRef as ReactComponent };